(function () {
    var STORAGE_KEY = 'wn-theme';
    var root = document.documentElement;

    // Ugrađeni alati (hr-ees, EES-RH) žive u iframeu i ne vide `data-theme`
    // roditeljske stranice — iframe zna samo za OS postavku. Kad čitatelj ručno
    // prebaci temu, njegov izbor gazi OS, pa bi alat ostao u krivoj temi:
    // svijetli pravokutnik nasred tamne stranice. Zato mu temu šaljemo porukom.
    //
    // Šalje se SAMO iframeovima s atributom `data-wn-theme-sync`, ne svima —
    // vanjski embedovi (video i slično) nemaju razloga primati naše poruke.
    // Odredište je izričito navedeno umjesto '*': alat je na drugoj domeni, pa
    // bi '*' značilo da poruku smije pročitati bilo tko tko se u međuvremenu
    // nađe u tom okviru (preusmjerenje, zamijenjen sadržaj).
    var ALAT_HOST = 'https://alt-aneri.github.io';

    function syncFrames(theme) {
        var frames = document.querySelectorAll('iframe[data-wn-theme-sync]');
        for (var i = 0; i < frames.length; i++) {
            try {
                frames[i].contentWindow.postMessage({wnTheme: theme}, ALAT_HOST);
            } catch (e) {}
        }
    }

    function currentTheme() {
        return root.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
    }

    document.addEventListener('DOMContentLoaded', function () {
        // iframe mora prvo biti učitan da bi imao tko primiti poruku
        var frames = document.querySelectorAll('iframe[data-wn-theme-sync]');
        for (var i = 0; i < frames.length; i++) {
            frames[i].addEventListener('load', function () {
                syncFrames(currentTheme());
            });
        }
        syncFrames(currentTheme());

        var toggle = document.querySelector('[data-theme-toggle]');
        if (!toggle) {
            return;
        }

        toggle.addEventListener('click', function () {
            var next = root.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
            root.setAttribute('data-theme', next);
            try {
                localStorage.setItem(STORAGE_KEY, next);
            } catch (e) {}
            syncFrames(next);
        });
    });
})();
